export default "__VITE_ASSET__fKoJTkaB__"